import React, { useState } from 'react';
import cn from 'classnames';
import styles from "./Signature.module.scss";
import { Spinner } from 'seagull';
import { useOnMount } from "../../../hooks/useOnMount";
export default function Signature(_ref) {
  let {
    children,
    className
  } = _ref;
  const [loading, setLoading] = useState(true);
  useOnMount(() => {
    document.fonts.ready.then(fonts => {
      // Firefox does not allow destructing FontFaceIterator, so I had to lookup manually
      const allFonts = fonts.values();
      let currentFont;
      while (currentFont = allFonts.next(), !currentFont.done) {
        if (currentFont.value.family.includes('AlexBrush-Regular')) {
          currentFont.value.loaded.then(() => setLoading(false));
        }
      }
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement(Spinner, {
    size: 40
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.signature, className, {
      [styles.hidden]: loading
    })
  }, children));
}